import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { BookingProductType } from 'parking-availability/js/propTypes'
import ScrollObserver from 'commons/js/util/ScrollObserver'
import SingleProductForm from './SingleProductForm'
import MultiProductForm from './MultiProductForm'
import ResumeBlock from './ResumeBlock'
import { Hide, Flex, Box } from '@elparking/components'

import DatesRange from './DatesRange'

const hasMultipleProducts = bookingProducts => bookingProducts.length > 1
const hasDatesSet = (startDate, endDate) => !!startDate && !!endDate
class ParkingRateForm extends PureComponent {
    static propTypes = {
        startDate: PropTypes.number,
        endDate: PropTypes.number,
        selectedBookingProduct: BookingProductType,
        bookingProducts: PropTypes.arrayOf(BookingProductType).isRequired,
        errors: PropTypes.arrayOf(
            PropTypes.shape({
                field: PropTypes.string,
                message: PropTypes.string,
            })
        ),
        isLoading: PropTypes.bool,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func,
    }

    static defaultProps = {
        isLoading: false,
        errors: [],
        onChange: () => {},
        onSubmit: () => {},
    }

    state = {
        observableElement: null,
    }

    onChange = this.onChange.bind(this)

    onChange (props) {
        this.props.onChange(props)
    }

    onSubmit = this.onSubmit.bind(this)

    onSubmit () {
        this.props.onSubmit()
    }

    setObservable (e) {
        this.setState({observableElement: e})
    }

    setObservable = this.setObservable.bind(this)

    onScrollClick () {
        const { observableElement } = this.state
        observableElement && observableElement.scrollIntoView()
    }

    onScrollClick = this.onScrollClick.bind(this)

    renderStiky (bookingProduct, showProduct = false) {
        const {
            startDate,
            endDate,
        } = this.props

        if (!startDate || !endDate) {
            return
        }

        if (!bookingProduct ||
            !bookingProduct.availability ||
            !bookingProduct.availability.priceQty) {
            return
        }

        return (
            <ResumeBlock
              onClick={this.onScrollClick}
              startDate={startDate}
              endDate={endDate}
              showProduct={showProduct}
              bookingProduct={bookingProduct} />
        )
    }

    renderProductForm () {
        const {
            bookingProducts,
            selectedBookingProduct,
            errors,
            isLoading,
            onSubmit,
            startDate,
            endDate,
        } = this.props

        const multiple = hasMultipleProducts(bookingProducts)
        const hasDates = hasDatesSet(startDate, endDate)

        if (multiple) {
            return (
                <div ref={this.setObservable}>
                    <MultiProductForm
                      bookingProducts={bookingProducts}
                      selectedBookingProduct={selectedBookingProduct}
                      errors={errors}
                      isLoading={isLoading}
                      onSubmit={onSubmit}
                      hasDates={hasDates}
                    />
                    <Hide md lg>
                        <ScrollObserver observableElement={this.state.observableElement} >
                            {this.renderStiky(selectedBookingProduct, true)}
                        </ScrollObserver>
                    </Hide>
                </div>
            )
        }

        return (
            <div ref={this.setObservable}>
                <SingleProductForm
                  bookingProduct={bookingProducts[0]}
                  errors={errors}
                  isLoading={isLoading}
                  onSubmit={onSubmit}
                  hasDates={hasDates}
                />
                <Hide md lg>
                    <ScrollObserver observableElement={this.state.observableElement} >
                        {this.renderStiky(bookingProducts[0])}
                    </ScrollObserver>
                </Hide>
            </div>
        )
    }
    render () {
        const {
            startDate,
            endDate,
            errors,
        } = this.props

        return (
            <div>
                <Flex flexWrap='wrap' alignItems='stretch' noValidate>
                    <Box flex='1 0 100%' mb='1em'>
                        <DatesRange
                          startDate={startDate}
                          endDate={endDate}
                          errors={errors}
                          onChange={this.onChange}
                        />
                    </Box>
                </Flex>
                { this.renderProductForm() }
            </div>
        )
    }
}

export default ParkingRateForm
